import Vue, { createApp } from 'vue'
import App from './App.vue'
import router from './router'
// import $ from 'jquery'
import './assets/css/style.css'
import './assets/css/global.css'
import animate from 'animate.css'
// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap/dist/js/bootstrap.bundle'
// import {getRequest} from "@/api/api";

// Vue.prototype.getRequest = getRequest;


// Vue.config.productionTip = false

// new Vue({
//   router,
//   render: h => h(App)
// }).$mount('#app')

const app = createApp(App)

app.use(router)

app.mount('#app')

app.use(animate)

router.afterEach((to, from, next) => {
    window.scrollTo(0, 0)
})